// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div_map[data-v-083a9fbc]{margin:0;padding:0;width:100%;height:100%;overflow:hidden;background:#f6f6f4}\n", ""]);
// Exports
module.exports = exports;
